export default __webpack_public_path__ + "static/media/bg-pattern-circle.2f3a4c70.svg";